//GET GEOIP 
  var defaultFetchParam = { method: 'GET',
               headers: new Headers({
					'Content-Type': 'application/json'
				}),
               mode: 'cors',
               cache: 'default' };
 var defaultFetchParamPost = { method: 'POST',
               headers: new Headers({
					'Content-Type': 'application/json'
				}),
               mode: 'cors',
               cache: 'default' };   
var isMegaMenuParentExist = false;

  window.addEventListener('DOMContentLoaded', (event) => {
    //console.log('DOM fully loaded and parsed');
    
    var isCcodeExist = getCookie('countryCode');
    //console.log("isCcodeExist", isCcodeExist);
    if (isCcodeExist == undefined || isCcodeExist == '') {
      defaultCountryByIPgg();
    }else{
      displayCountry(isCcodeExist);
    }

    
  });
  
var noFreeShippingCountries = ["RU","MY", "AF", "AS", "AI", "AG", "BZ", "BT", "BO", "VG", "CU", "CW", "KP" , "DM", "EC", "GM", "GD", "GM", "GT", "HT", "HN", "IR", "JM", "LV", "LR", "MA", "NP", "NC", "NI", "PS", "PY", "KN", "SK", "SO", "SS", "SY", "TJ", "TK", "TM", "UG", "VE", "YE", "KV", "BR"];
  //Afghanistan, American Samoa, Anguilla, Antigua and Barbuda, Belize, Bhutan, Bolivia, Bouvet Island, British Virgin Islands, Cuba, Curacao, Dem People's Rep. of Korea, Dominica, Ecuador, Gambia, Grenada, Guatemala, Haiti, Honduras (Rep.), Iran (Islamic Rep.), Jamaica, Latvia, Liberia, Malaysia, Morocco, Nepal, New Caledonia, Nicaragua, Palestine Territories, Paraguay, Saint Kitts and Nevis, Slovakia, Somalia, South Sudan (Rep.),Syrian Arab Rep., Tajikistan, Tokelau, Turkmenistan, Uganda, Venezuela, Yemen and Kosovo
  

function displayCountry(countryCode){
  //console.log("countryCode ~", countryCode);
  if(!noFreeShippingCountries.includes(countryCode)){
    
	//console.log("countryCode in geopIP", countryCode);
    
    var cName = getCookie('countryName');
    if(document.getElementById('shippingHeaderText') != null){
      document.getElementById('shippingHeaderText').innerText = cName;
    }
    if(document.getElementById('shippingLogoText') != null){
      document.getElementById('shippingLogoText').innerText = cName;
    }
    if(document.getElementById('shippingProductDetail') != null){
      document.getElementById('shippingProductDetail').innerText = cName;
    }

    if(document.getElementById('shippingHeaderGeoip') != null){
      document.getElementById('shippingHeaderGeoip').style.display = "inline-block";
    }

    if(document.getElementById('shippingLogoGeoip') != null){
      document.getElementById('shippingLogoGeoip').style.display = "inline-block";
    }

    if(document.getElementById('shippingProductGeoip') != null){
      document.getElementById('shippingProductGeoip').style.display = "inline-block";
    }

  }else{
    
   
     setTimeout(function(){
        var shippingcartdiv =  document.getElementsByClassName("cart-est-shipping-cost");
        if (shippingcartdiv != undefined){
          //console.log("this code of shipping code is running");
          var cartshippingcost = document.getElementsByClassName("cart-est-shipping-cost");
          if(cartshippingcost.length > 0 ){
              document.getElementsByClassName("cart-est-shipping-cost")[0].setAttribute("style", "display:none;");
          }     
        }
       
     },2000); //delay is in milliseconds 
  }
}


function defaultCountryByIPgg(){
  console.log("defaultCountryByIPgg");

    var geoipUrl = "https://api.pinkyparadise.com/public/geoip";
    //console.log("geoipUrl", geoipUrl);
    fetch(geoipUrl, defaultFetchParam)
    .then(function(response) {
      return response.json()})
    .then(function(result) {
      console.log("result geoip", result);
      if (result.status == "00") {
        //document.getElementById('lstCountry').value = result.countryCode;
         cookie('countryCode', result.countryCode,{path:'/',expires:1});
         cookie('countryName', result.countryName,{path:'/',expires:1});
         displayCountry(result.countryCode);
      }
    });
}

function getFullIpInfo(){
  
//var goEndPointDEV = "https://4644-2001-e68-633c-b00-1cde-49c3-9559-e848.ngrok.io/";	

      var url = endPoint + "/api/spy/getfullip";
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
              
                var jsonResp = JSON.parse(xhttp.responseText);
                console.log("jsonResp full info", jsonResp);
              
                  if (jsonResp){
                    
                    cookie('country_name', jsonResp.country_name,{path:'/',expires:1});
                    cookie('city', jsonResp.city,{path:'/',expires:1});
                    cookie('postal', jsonResp.postal,{path:'/',expires:1});

                  }
              }
          };
  
       xhttp.open("GET", url, true);
       xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
   
       xhttp.send();  
}